import AdminApi from '../../services/api'
import swal from 'sweetalert2';
import session from "../../services/session";
import Loc from "../../services/localization";
import AutocompleteObject from "../Shared/AutocompleteObject";

const AdminApiService = new AdminApi()
const LocService = new Loc()

export default {
    data() {
        return {
            locale: LocService,
            filter: '',
            internalCode: '',
            myUsername: '',
            showFilters: false,
            showSort: false,
            sorts: [LocService.t('label_sort_by_date'), LocService.t('label_sort_by_abs')],
            role: '',
            allCategories: [],
            categories: [],
            selectedSubCategories: [],
            visibleCategory: true,
            visibleSubCategory: true,
            newSelectedCategory: '',
            newSelectedSubCategory: '',
            sort: 'date',
            selectedSort: LocService.t('label_sort_by_date'),
            statuses: [
                {
                    id: 1,
                    state: 'ALL',
                    name: LocService.t('label_article_all')
                },
                {
                    id: 2,
                    state: 'FOR_APPROVE',
                    name: LocService.t('label_article_for_approve')
                },
                {
                    id: 3,
                    state: 'ACTIVE',
                    name: LocService.t('label_article_active')
                },
                {
                    id: 4,
                    state: 'SERVICE',
                    name: LocService.t('label_article_service')
                },
                {
                    id: 6,
                    state: 'SENT_BY_POST',
                    name: LocService.t('label_article_sent_by_post')
                },
                {
                    id: 5,
                    state: 'SOLD',
                    name: LocService.t('label_article_sold')
                },
                {
                    id: 7,
                    state: 'ARCHIVED',
                    name: LocService.t('label_article_archived')
                }
            ],
            selectedStatus: {
                id: 1,
                state: 'ALL',
                name: LocService.t('label_article_all')
            },
            fromDate: null,
            toDate: null,
            reportLoading: false,
            reportLoaded: false,
            reportData: null,
            articleLogLoading: false,
            articleLogLoaded: false,
            articleLogRows: [],
            cScheduleLoading: false,
            cScheduleLoaded: false,
            cScheduleRows: []
        }
    },
    components: {AutocompleteObject},
    methods: {
        load: load,
        formatDate: formatDate,
        clearFilters: clearFilters,
        getChipClass: getChipClass,
        isSelected: isSelected,
        getChipClassSort: getChipClassSort,
        isSelectedSort: isSelectedSort,
        onSelectedSort: onSelectedSort,
        keymonitor: keymonitor,
        clickSearch: clickSearch,
        loadArticleLogReport: loadArticleLogReport,
        loadCScheduleReport: loadCScheduleReport,
        canSeeReport: canSeeReport,
        canSeeOnlyKp: canSeeOnlyKp,
        isMobile: isMobile,
        chartWidth: chartWidth,
        formatMoney: formatMoney,
        formatPercent: formatPercent,
        isNumberPositive: isNumberPositive,
        getArticleLogUserName: getArticleLogUserName,
        getCScheduleUserName: getCScheduleUserName
    },
    computed: {
        normalizedReport() {
            return normalizeReport(this.reportData);
        },
        hasReportData() {
            var data = this.normalizedReport;
            if (!this.reportLoaded || data == null) return false;

            return data.totalArticles > 0 ||
                data.totalProfitEur !== 0 ||
                data.totalPurchaseEur !== 0;
        },
        summaryCards() {
            var data = this.normalizedReport;
            if (data == null) return [];

            return [
                {
                    key: 'totalArticles',
                    title: this.locale.t('label_total_articles'),
                    value: data.totalArticles,
                    type: 'count'
                },
                // {
                //     key: 'purchaseTotal',
                //     title: this.locale.t('label_total_price'),
                //     value: this.formatMoney(data.totalPurchaseEur) + ' EUR',
                //     type: 'text'
                // },
                {
                    key: 'profitTotal',
                    title: this.locale.t('label_total_profit'),
                    value: this.formatMoney(this.effectiveTotalProfitEur) + ' EUR',
                    type: 'text',
                    positive: this.isNumberPositive(this.effectiveTotalProfitEur)
                }
            ];
        },
        profitChartData() {
            var data = this.normalizedReport;
            if (data == null) return [];
            return [
                { label: 'EUR', value: data.totalProfitEur, accent: 'articles-report__bar--profit-eur' }
            ];
        },
        purchaseChartData() {
            var data = this.normalizedReport;
            if (data == null) return [];
            return [
                { label: 'EUR', value: data.totalPurchaseEur, accent: 'articles-report__bar--purchase-eur' }
            ];
        },
        maxProfitValue() {
            return getMaxValue(this.profitChartData);
        },
        maxPurchaseValue() {
            return getMaxValue(this.purchaseChartData);
        },
        articleLogTotalPostOnKp() {
            return (this.articleLogRows || []).reduce(function (sum, row) {
                return sum + toNumber(row.postOnKpCount);
            }, 0);
        },
        articleLogTotalSelling() {
            return (this.articleLogRows || []).reduce(function (sum, row) {
                return sum + toNumber(row.sellingCount);
            }, 0);
        },
        articleLogTotalUploadedImages() {
            return (this.articleLogRows || []).reduce(function (sum, row) {
                return sum + toNumber(row.uploadedImages);
            }, 0);
        },
        articleLogPostChartData() {
            return (this.articleLogRows || [])
                .map((row, idx) => ({
                    key: row.userId != null ? row.userId : idx,
                    label: this.getArticleLogUserName(row) || ('#' + (row.userId || '/')),
                    value: toNumber(row.postOnKpCount)
                }))
                .sort(function (a, b) {
                    return b.value - a.value;
                });
        },
        articleLogSoldChartData() {
            return (this.articleLogRows || [])
                .map((row, idx) => ({
                    key: row.userId != null ? row.userId : idx,
                    label: this.getArticleLogUserName(row) || ('#' + (row.userId || '/')),
                    value: toNumber(row.sellingCount)
                }))
                .sort(function (a, b) {
                    return b.value - a.value;
                });
        },
        articleLogUploadedImagesChartData() {
            return (this.articleLogRows || [])
                .map((row, idx) => ({
                    key: row.userId != null ? row.userId : idx,
                    label: this.getArticleLogUserName(row) || ('#' + (row.userId || '/')),
                    value: toNumber(row.uploadedImages)
                }))
                .sort(function (a, b) {
                    return b.value - a.value;
                });
        },
        maxArticleLogPostValue() {
            return getMaxValue(this.articleLogPostChartData);
        },
        maxArticleLogSoldValue() {
            return getMaxValue(this.articleLogSoldChartData);
        },
        maxArticleLogUploadedImagesValue() {
            return getMaxValue(this.articleLogUploadedImagesChartData);
        },
        cScheduleTotalTurnoverEur() {
            return (this.cScheduleRows || []).reduce(function (sum, row) {
                return sum + toNumber(row.turnoverEur);
            }, 0);
        },
        cScheduleTotalTurnoverRsd() {
            return (this.cScheduleRows || []).reduce(function (sum, row) {
                return sum + toNumber(row.turnoverRsd);
            }, 0);
        },
        cScheduleTotalProfitEur() {
            return (this.cScheduleRows || []).reduce(function (sum, row) {
                return sum + toNumber(row.profitEur);
            }, 0);
        },
        sortedCScheduleRows() {
            return (this.cScheduleRows || [])
                .slice()
                .sort(function (a, b) {
                    return toNumber(b.profitEur) - toNumber(a.profitEur);
                });
        },
        cScheduleProfitChartData() {
            return this.sortedCScheduleRows.map((row, idx) => ({
                key: row.userId != null ? row.userId : idx,
                label: this.getCScheduleUserName(row) || (row.username || '/'),
                value: toNumber(row.profitEur)
            }));
        },
        maxCScheduleProfitValue() {
            return getMaxValue(this.cScheduleProfitChartData);
        },
        effectiveTotalProfitEur() {
            if (this.cScheduleLoaded) {
                return toNumber(this.cScheduleTotalProfitEur);
            }
            var data = this.normalizedReport;
            return data != null ? toNumber(data.totalProfitEur) : 0;
        }
    },
    beforeMount() {
        if (session.getAccessToken() == null || session.getAccessToken() === '') {
            this.$router.push('/login');
            return;
        }

        this.role = session.getRole();
        this.myUsername = session.getUsername();

        if (session.getCategories() != null) {
            this.allCategories = session.getCategories();
            this.categories = this.allCategories.filter(function (e) {
                return e.parentCategory == null;
            }).map(function (m) {
                return m.name;
            });
        }
    },
    watch: {
        showFilters: function (val) {
            if (val === false) {
                this.clearFilters();
            }
        },
        newSelectedCategory: function (val) {
            this.visibleCategory = isEmptyValue(val);
            if (!isEmptyValue(val)) {
                this.selectedSubCategories = this.allCategories.filter(function (e) {
                    return e.parentCategory === val;
                }).map(function (m) {
                    return m.name;
                });
            } else {
                this.selectedSubCategories = [];
                this.newSelectedSubCategory = '';
            }
        },
        newSelectedSubCategory: function (val) {
            this.visibleSubCategory = isEmptyValue(val);
        }
    }
}

function canSeeReport() {
    return ((session.getUsername() === 'acoadmin') || session.getRole() === 'ROLE_SUPER_ADMIN') || this.canSeeOnlyKp();
}

function canSeeOnlyKp() {
    return session.getUsername() === 'milan_j';
}

function isMobile() {
    return window.innerWidth <= 850;
}

function clickSearch() {
    this.load();
    this.loadArticleLogReport();
    this.loadCScheduleReport();
}

function load() {
    var _self = this;

    _self.reportLoading = true;
    _self.reportLoaded = false;

    var request = {
        filter: _self.filter,
        internalCode: _self.internalCode,
        mainCategory: _self.newSelectedCategory,
        subCategory: _self.newSelectedSubCategory,
        state: _self.selectedStatus.state,
        fromDate: _self.fromDate != null ? _self.$moment(_self.fromDate).format('DD-MM-YYYY') : null,
        toDate: _self.toDate != null ? _self.$moment(_self.toDate).format('DD-MM-YYYY') : null
    }

    AdminApiService.getArticlesReport(request)
        .then(function (response) {
            _self.reportData = response.data || {};
            _self.reportLoaded = true;
            _self.reportLoading = false;
        })
        .catch(function (error) {
            _self.reportLoading = false;
            _self.reportLoaded = false;
            swal(LocService.t('label_error'), error.data.localized_error_message, 'error')
        })
}

function formatDate(date) {
    return this.$moment(new Date(date * 1000)).format('DD-MM-YYYY')
}

function keymonitor(event) {
    if (event.key === 'Enter') {
        this.clickSearch();
    }
}

function loadArticleLogReport() {
    var _self = this;

    var hasFromDate = _self.fromDate != null && _self.fromDate !== '';
    var hasToDate = _self.toDate != null && _self.toDate !== '';

    var fromMoment = hasFromDate ? _self.$moment(_self.fromDate) : null;
    var toMoment = hasToDate ? _self.$moment(_self.toDate) : null;

    if ((hasFromDate && !fromMoment.isValid()) || (hasToDate && !toMoment.isValid())) {
        _self.articleLogRows = [];
        _self.articleLogLoaded = false;
        swal(LocService.t('label_error'), LocService.t('label_invalid_date'), 'error');
        return;
    }

    if (hasFromDate && hasToDate && fromMoment.isAfter(toMoment)) {
        _self.articleLogRows = [];
        _self.articleLogLoaded = false;
        swal(LocService.t('label_error'), LocService.t('label_article_log_invalid_period'), 'error');
        return;
    }

    _self.articleLogLoading = true;
    _self.articleLogLoaded = false;

    var request = {
        fromDate: hasFromDate ? fromMoment.format('DD-MM-YYYY') : null,
        toDate: hasToDate ? toMoment.format('DD-MM-YYYY') : null
    };

    AdminApiService.getArticleLogReport(request)
        .then(function (response) {
            _self.articleLogRows = Array.isArray(response.data) ? response.data : [];
            _self.articleLogLoaded = true;
            _self.articleLogLoading = false;
        })
        .catch(function (error) {
            _self.articleLogRows = [];
            _self.articleLogLoaded = false;
            _self.articleLogLoading = false;
            swal(LocService.t('label_error'), error.data.localized_error_message, 'error')
        })
}

function loadCScheduleReport() {
    var _self = this;

    var hasFromDate = _self.fromDate != null && _self.fromDate !== '';
    var hasToDate = _self.toDate != null && _self.toDate !== '';

    var fromMoment = hasFromDate ? _self.$moment(_self.fromDate) : null;
    var toMoment = hasToDate ? _self.$moment(_self.toDate) : null;

    if ((hasFromDate && !fromMoment.isValid()) || (hasToDate && !toMoment.isValid())) {
        _self.cScheduleRows = [];
        _self.cScheduleLoaded = false;
        swal(LocService.t('label_error'), LocService.t('label_invalid_date'), 'error');
        return;
    }

    if (hasFromDate && hasToDate && fromMoment.isAfter(toMoment)) {
        _self.cScheduleRows = [];
        _self.cScheduleLoaded = false;
        swal(LocService.t('label_error'), LocService.t('label_article_log_invalid_period'), 'error');
        return;
    }

    _self.cScheduleLoading = true;
    _self.cScheduleLoaded = false;

    var request = {};
    if (hasFromDate) request.fromDate = fromMoment.format('DD-MM-YYYY');
    if (hasToDate) request.toDate = toMoment.format('DD-MM-YYYY');

    AdminApiService.getCScheduleReport(request)
        .then(function (response) {
            _self.cScheduleRows = Array.isArray(response.data) ? response.data : [];
            _self.cScheduleLoaded = true;
            _self.cScheduleLoading = false;
        })
        .catch(function (error) {
            _self.cScheduleRows = [];
            _self.cScheduleLoaded = false;
            _self.cScheduleLoading = false;
            swal(LocService.t('label_error'), error.data.localized_error_message, 'error')
        })
}

function clearFilters() {
    this.newSelectedCategory = '';
    this.newSelectedSubCategory = '';
    this.fromDate = null;
    this.toDate = null;
}

function getChipClass(item) {
    if (this.selectedStatus.id === item.id) {
        return 'chip-selected'
    }
    return 'chip-unselected'
}

function isSelected(item) {
    return this.selectedStatus.id === item.id
}

function getChipClassSort(item) {
    if (this.selectedSort === item) {
        return 'chip-selected'
    }
    return 'chip-unselected'
}

function isSelectedSort(item) {
    return this.selectedSort === item
}

function onSelectedSort(item) {
    this.selectedSort = item;
    if (this.selectedSort === LocService.t('label_sort_by_abs')) {
        this.sort = 'abc'
    } else {
        this.sort = 'date'
    }
}

function normalizeReport(data) {
    if (data == null) return null;

    var totalArticles = toNumber(data.totalArticles);
    var totalProfitRsd = toNumber(data.totalProfitRsd);
    var totalProfitEur = toNumber(data.totalProfitEur);
    var totalPurchaseRsd = toNumber(data.totalPurchasePriceRsd);
    var totalPurchaseEur = toNumber(data.totalPurchasePriceEur);

    if (totalProfitEur === 0 && totalProfitRsd !== 0) {
        totalProfitEur = totalProfitRsd / 117.5;
    }

    if (totalPurchaseEur === 0 && totalPurchaseRsd !== 0) {
        totalPurchaseEur = totalPurchaseRsd / 117.5;
    }

    var marginRsd = totalPurchaseRsd > 0 ? ((totalProfitRsd / totalPurchaseRsd) * 100) : 0;
    var marginEur = totalPurchaseEur > 0 ? ((totalProfitEur / totalPurchaseEur) * 100) : 0;

    return {
        totalArticles: Math.max(0, Math.round(totalArticles)),
        totalProfitRsd: totalProfitRsd,
        totalProfitEur: totalProfitEur,
        totalPurchaseRsd: totalPurchaseRsd,
        totalPurchaseEur: totalPurchaseEur,
        marginRsd: marginRsd,
        marginEur: marginEur
    };
}

function toNumber(value) {
    if (value == null || value === '') return 0;
    var n = Number(value);
    if (isNaN(n)) return 0;
    return n;
}

function chartWidth(value, max) {
    var v = toNumber(value);
    var m = toNumber(max);
    if (m <= 0) return '8%';
    var ratio = (v / m) * 100;
    return Math.max(8, Math.min(100, ratio)).toFixed(2) + '%';
}

function getMaxValue(list) {
    if (list == null || list.length === 0) return 0;
    var values = list.map(function (x) {
        return toNumber(x.value);
    });
    return Math.max.apply(Math, values);
}

function formatMoney(value) {
    return new Intl.NumberFormat('sr-RS', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    }).format(toNumber(value));
}

function formatPercent(value) {
    return toNumber(value).toFixed(2) + '%';
}

function isNumberPositive(value) {
    return toNumber(value) > 0;
}

function isEmptyValue(value) {
    return value == null || String(value).trim() === '';
}

function getArticleLogUserName(row) {
    var name = row && row.name ? String(row.name) : '';
    var surname = row && row.surname ? String(row.surname) : '';
    return (name + ' ' + surname).trim();
}

function getCScheduleUserName(row) {
    var name = row && row.firstName ? String(row.firstName) : '';
    var surname = row && row.lastName ? String(row.lastName) : '';
    return (name + ' ' + surname).trim();
}



// WEBPACK FOOTER //
// ./src/components/Article/ArticlesReport.js